import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { stepsActions } from '../../../store/modules/steps/reducer';
import { formSummarySelector, stepsSelector } from '../../../store/modules/steps/selectors';
import { translationsSelector } from '../../../store/modules/translations/selectors';
import { StepsState, StepTemplate } from '../../../model/global';
import IconRenderer from 'global/react-mui/atoms/IconRenderer';
import ResumeSlice from './ResumeSlice';

const FormStepSummary: React.FC<any> = () => {

	const dispatch = useDispatch()
	const allSteps = useSelector(stepsSelector).steps;
	const summary = useSelector(formSummarySelector) as StepsState['formSummary']

	const jumpToStep = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, stepIndex: number): void => {
		event && event.preventDefault();
		dispatch(stepsActions.setRequestedStep(stepIndex))
	}

	return (
		<React.Fragment>
			{allSteps?.map((theStep, stepIndex) => {

				if (theStep.stepTemplate === 'FORM_SUMMARY') return null // ignore summary fields!
				return (
					<div key={`summary-${theStep.stepTemplate}`} className={'resume'}>

						<div className="uk-flex uk-flex-between">
							<div className={'resume-title'}>{theStep.stepData.fieldTranslations.stepText} {stepIndex + 1}: {theStep.stepTitle}</div>
							<a onClick={e => jumpToStep(e, stepIndex)}>
								<IconRenderer
									shape="squared"
									// bgColor="#E0E0E0"
									color="#A7A7A7"
									icon={'penCircle'}
								/>
							</a>
						</div>

						{/* apply a specific resume slice for file uploads, since they are structured differently and dynamic */}
						{(Object.entries(theStep?.stepData?.fields)
								?.map(([fieldsKeyName, formFields], fieldMapIndex) => {

									// loop through each field
									// build a custom list of form fields to be displayed on this resume slice,
									// excluding one's which should not show in the summary
									const formFieldsList = formFields.filter(f => !f.excludeFromSummary);
									if (formFieldsList.length === 0) return null
									const resumeSliceTitle = theStep.stepData.fieldTranslations[fieldsKeyName] || ''
									const sliceKeyName = fieldsKeyName + fieldMapIndex.toString();
									return (
										<ResumeSlice key={sliceKeyName} {
											...{
												formFieldsList,
												sliceKeyName,
												theStep,
												sliceTitle: resumeSliceTitle
											}
										} />
									)
								})
							)
						}
					</div>
				)
			})}
		</React.Fragment>
	);
};

export default memo(FormStepSummary);
